/**
 * External dependencies
 */
import { combineReducers } from "redux";

/**
 * Internal dependencies
 */
import { SECTION_SET } from "state/action-types";
import route from "./route/reducer";
import modal from "./modal/reducer";
import dateRange from "./date-range/reducer";
import dashboardForm from "./dashboard-form/reducer";
import dashboardFilter from "./dashboard-filter/reducer";
import reportBuilder from "./report-builder/reducer";
import reportRenameForm from "./report-rename-form";
import locationFilter from "./location-filter/reducer";

export const hasSidebar = (state = true, action) => {
  switch (action.type) {
    case SECTION_SET:
      return action.hasSidebar !== undefined ? action.hasSidebar : state;
    default:
      return state;
  }
};

export const section = (state = false, action) => {
  switch (action.type) {
    case SECTION_SET:
      return action.section !== undefined ? action.section : state;
    default:
      return state;
  }
};

export const isLoading = (state = false, action) => {
  switch (action.type) {
    case SECTION_SET:
      return action.isLoading !== undefined ? action.isLoading : state;
    default:
      return state;
  }
};

const reducer = combineReducers({
  dateRange,
  dashboardFilter,
  hasSidebar,
  modal,
  route,
  section,
  isLoading,
  dashboardForm,
  reportBuilder,
  reportRenameForm,
  locationFilter,
});

export default reducer;
